import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'blog-newsletter-link',
    templateUrl: './blog-newsletter-link.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule, RouterLink]
})
export class BlogNewsletterLinkComponent {
}
